const sum = (a, b) => a + b;

export { sum };
//# sourceMappingURL=sum.js.map
